import * as PIXI from "pixi";

import { DeobfuPiouPiouzLevel } from "piou-core/types";
import levelJson from "./529.json";

import Debug from "./game/Debug";
import Loader from "./Loader";
import GameUI from "./ui/GameUI";

async function main() {
  const loader = new Loader(
    window.innerWidth,
    window.innerHeight,
    document.body,
    levelJson as unknown as DeobfuPiouPiouzLevel,
    GameUI
  );

  const gameUI = await loader.load();

  window.addEventListener("resize", () => {
    gameUI.resize(window.innerWidth, window.innerHeight);
  });

  new Debug(gameUI.game);
}

main();
